import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URLS, PLATFORM_TYPE } from "../../constants/constants";

export const loginApi = createApi({
  reducerPath: "loginApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URLS.USERMANAGEMENT_BASE_URL,
    prepareHeaders: (headers) => {
      // headers.set("authorization", `Bearer ${localStorage.access_token}`);
      // headers.set("currentRole", localStorage.userrole);
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      if(localStorage.userrole === "eci")
      {
        headers.set("state", "master");
      }
      return headers;
    }, }),
    keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    perfromlogin: builder.mutation({
      query: () => ({
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": "true",
          Authorization: 'Bearer ' + localStorage.access_token,
          currentRole: localStorage.userrole,
        },
        url: "api/v1/user-management/auth/login",
        method: "POST",
        body: {},

        // responseHandler: (response) => response.text(),
      }),
    }),
    changePassword: builder.mutation({
      query: (data) => ({
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.access_token,
          currentRole: localStorage.userrole,
        },
        url: `/api/v1/user-management/change/user/password`,
        method: "POST",
        body: data,
      }),
    }),

    ///////////FORGOT PASSWORD API's////////////////
    getActionButtons: builder.mutation({
      query: (filter) => ({
        url: `${BASE_URLS.USERMANAGEMENT_WORKFLOW_BASE_URL}api/v1/workflow/forgot/process/action`,
        method: "POST",
        body: filter,
        headers:{
          "state":"master"
        }
      }),
    }),

    getDetails: builder.query({
      query: (unique) => ({
        url: `api/v1/user-management/user/getDetails/`,
        method: "GET",
        params: {
          unique: unique,
        },
        headers: {
          // "Authorization":localStorage.access_token,
          // "currentRole":localStorage.userrole,
          "state":"master"
        },
      }),
    }),

    eciForgotPassword: builder.mutation({
      query: (data) => ({
        url: `api/v1/user-management/forgot/password`,
        method: "POST",
        body: data,
        headers: {
          "Authorization":'Bearer ' + localStorage.access_token,
          "currentRole":localStorage.userrole,
          "state":"master"
        },
      }),
    }),

    createPasswordRequest: builder.mutation({
      query: (data) => ({
        url: `api/v1/user-management/forgot/password/request`,
        method: "POST",
        body: data[0],
        headers: {
          "Authorization":'Bearer ' + localStorage.access_token,
          "currentRole":localStorage.userrole,
          "state":data[1],
          workflowConfigId:data[2]
          // "state":"master"
        },
      }),
    }),

    getPasswordRequests: builder.query({
      keepUnusedDataFor: 0,
      query: () => ({
        url: `api/v1/user-management/forgot/getall/requests`,
        method: "GET",
        // params: {
        //   unique: unique,
        // },
        headers: {
          "Authorization":'Bearer ' + localStorage.access_token,
          "currentRole":localStorage.userrole,
          "state":"master"
        },
      }),
    }),

    getECIPasswordRequests: builder.query({
      keepUnusedDataFor: 0,
      query: () => ({
        url: `api/v1/user-management/forgot/getall/central/requests`,
        method: "GET",
        // params: {
        //   unique: unique,
        // },
        headers: {
          "Authorization":'Bearer ' + localStorage.access_token,
          "currentRole":localStorage.userrole,
        },
      }),
    }),

    passwordRequestAction: builder.mutation({
      query: (data) => ({
        url: `api/v1/user-management/forgot/password/approve/${data.isAccept}`,
        method: "POST",
        params:{
          requestId: data.requestId,
          stateCd : localStorage.userrole ==="eci" ? data.stateCd : "",
        },
        headers: {
          "Authorization":'Bearer ' + localStorage.access_token,
          "currentRole":localStorage.userrole,
          // "state":"master"
        },
      }),
    }),

    getActions: builder.query({
      query: (data) => ({
        url: `${BASE_URLS.USERMANAGEMENT_WORKFLOW_BASE_URL}api/v1/workflow/actions/byRole`,
        method: "GET",
        params:{
          role: data.role,
          processMasterId:data.processMasterId,
        },
        headers: {
          "Authorization":'Bearer ' + localStorage.access_token,
          "currentRole":localStorage.userrole,
          "state":"master"
        },
      }),
    }),
  }),
});
export const {
  usePerfromloginMutation,
  useChangePasswordMutation,
  useGetDetailsQuery,
  useGetActionButtonsMutation,
  useEciForgotPasswordMutation,
  useCreatePasswordRequestMutation,
  useGetPasswordRequestsQuery,
  useGetECIPasswordRequestsQuery,
  usePasswordRequestActionMutation,
  useGetActionsQuery
} = loginApi;
